S.contentSwitch = {
    $ajaxUrl: '/api/contentswitch.json',

    init()
    {
        this.$module.find('select').on('change', (e) =>
        {
            this.$module.hide();
            $('.js-content-wrapper').addClass('is-loading');
            this.doRequest($(e.target).val());
        });
    },

    /**
     *
     * @param {int}languageID
     */
    doRequest(languageID)
    {
        $.ajax({
            type: 'POST',
            url: this.$ajaxUrl,
            dataType: 'json',
            data: {
                'tx_projectsasi_ajax[pageId]': this.$module.find('input[name="pageid"]').val(),
                'tx_projectsasi_ajax[languageId]': languageID,
            },

            // Success state
            success: (data) =>
            {
                $('.js-content-wrapper').html(data.html);

                setTimeout(() =>
                {
                    $('.js-content-wrapper').removeClass('is-loading');
                    this.$module.show();
                }, 100);

            },

            // Error state
            error: (e) =>
            {
                console.log(e);
            },
        });
    },

};
